import styled from 'styled-components/macro'
import bg from './cbus-new.png'
import bgDemo from './demo.jpg'

import { getGelTokens } from '@tal-gel/theming'

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (min-width: 768px) {
    width: 100%;
    max-width: 1032px;
  }
`

const ButtonWrapper = styled.div`
  display: none;

  @media only screen and (min-width: 768px) {
    display: flex;
    align-items: center;
  }
`

const Hero = styled.div`
  padding: 80px 24px;
  background: ${(props) => (props.demo ? `url(${bgDemo})` : `url(${bg})`)}
    no-repeat top center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: ${(props) => (props.grow ? 1 : 0)};

  @media only screen and (min-width: 768px) {
    min-height: 516px;
    padding: 186px 68px;
  }
`

const HeaderTitle = styled.h4`
  font-family: 'Pluto Sans', sans-serif;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: ${(props) => props.theme.colors.brand.primary};
  margin-bottom: 8px;
  text-align: ${(props) => (props.center ? 'center' : 'left')};

  @media only screen and (min-width: 768px) {
    font-size: 32px;
    line-height: 40px;
  }
`

const Content = styled.div`
  padding: 80px 20px;
  background-color: ${() => getGelTokens().brand.brandColorGrayT05};

  @media only screen and (min-width: 768px) {
    padding: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

const EmailSection = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;

  @media only screen and (min-width: 768px) {
    margin-top: 0;
    margin-bottom: 40px;
  }
`

const EmailWrapper = styled.div`
  margin-top: 16px;

  @media only screen and (min-width: 768px) {
    margin-top: 24px;
  }
`

export {
  Header,
  HeaderWrapper,
  HeaderTitle,
  ButtonWrapper,
  Hero,
  Content,
  EmailSection,
  EmailWrapper
}
